import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
import { Outlet } from "react-router";
import { useAuthService } from "../../adapters/auth/useAuthService.ts";
import { useAppName } from "../../adapters/insights-agent/state/hooks/useAppName.ts";
import { useConfig } from "../../adapters/insights-agent/state/hooks/useConfig.ts";
import { useFeatureFlagValue } from "../../config/FeatureFlagManager/hooks.ts";
import { Header } from "../../feature-components/Header/Header.tsx";
import styles from "./ClaLayout.module.css";
import { ConnectedHistorySidebar } from "./components/ConnectedHistorySidebar.tsx";

export const ClaLayout = () => {
  const authService = useAuthService();
  const { environment } = useConfig();
  const enableGlobalNav = useFeatureFlagValue("enableGlobalNav");
  return (
    <div className={styles.ClaLayout}>
      <Header
        isAuthenticated
        enableGlobalNav={enableGlobalNav}
        onLogoutClick={authService.logout}
        env={environment}
        appTitle={useAppName()}
      />
      <div className={styles.WorkflowGrid}>
        <PanelGroup direction="horizontal" autoSaveId="workflow-layout">
          <Panel minSize={10} defaultSize={13}>
            <ConnectedHistorySidebar />
          </Panel>
          <PanelResizeHandle className={styles.ResizeHandle} />
          <Panel minSize={50} defaultSize={50}>
            <Outlet />
          </Panel>
        </PanelGroup>
      </div>
    </div>
  );
};
